import React from 'react';

import DateFilters from '@swf/sports/components/DateFilters/DateFilters';

import useDateFilters from '../../hooks/useDateFilters';
import MyBets from '../MyBets/MyBets';

interface Props {
  cashedOut?: Record<string, number | undefined>;
}

const MyBetsWithFilters: React.FC<Props> = ({ cashedOut }) => {
  const { fromDate, toDate, selectFromDate, selectToDate, minDate, maxDate } = useDateFilters();

  return (
    <>
      <DateFilters
        fromDate={fromDate}
        toDate={toDate}
        minDate={minDate}
        maxDate={maxDate}
        selectFromDate={selectFromDate}
        selectToDate={selectToDate}
      />
      <MyBets isSettled fromDate={fromDate} toDate={toDate} cashedOut={cashedOut} />
    </>
  );
};

export default MyBetsWithFilters;
